<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="quotationForm"
          :model="quotation"
          label-width="70px"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
              <span v-if="quotation.hasInv" class="float-right"
                >{{ $t("quotation.hasInv") }}：{{
                  $t("boolean." + quotation.hasInv)
                }}</span
              >
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  quotation.product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  quotation.product.unit
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  quotation.product.categoryName
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('quotation.price')">{{
                  quotation.price | currency
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.suppliers')">{{
                  quotation.supplierName
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset
            v-if="quotation.product && quotation.product.images != null"
            class="mgb15"
          >
            <legend>{{ $t("product.images") }}</legend>
            <thumbnail
              :images="quotation.product.images"
              :list="true"
              width="50"
              height="auto"
            />
          </fieldset>
          <fieldset
            v-if="quotation.product && quotation.product.introduction != null"
            class="mgb15"
          >
            <legend>{{ $t("product.introduction") }}</legend>
            <raw-html :content="quotation.product.introduction" />
          </fieldset>
          <fieldset
            v-if="
              quotation.quotationSizePrices &&
              quotation.quotationSizePrices.length != 0
            "
            class="mgb15"
          >
            <legend>{{ $t("product.sizePrice") }}</legend>
            <vxe-table
              :data="quotation.quotationSizePrices"
              id="priceTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="size" :title="$t('product.size')" />
              <vxe-table-column field="price" :title="$t('quotation.price')">
                <template v-slot="{ row }">{{ row.price | currency }}</template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtml from "@/components/RawHtml";
import Quotation from "@/api/quotation.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Thumbnail,
    RawHtml,
  },
  data() {
    return {
      quotation: { hasInv: false, product: { productNo: null } },
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Quotation.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.quotation = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>